import i18next from 'i18next';

import { createAjaxAction } from '../../../Common/_actions/AjaxAction';
import { Toast } from '../../../UIData/_actions/UIDataActions';
import type { ProductPublishJobPayload } from '../../_stores/Store/ProductPublish/ProductPublishJobStore';
import type { ProductPublishResponse } from '../../_stores/Store/ProductPublish/ProductPublishSummaryStore';

export enum StoreProductPublishJobActionType {
	PublishProductListings = 'STORE_PRODUCT_PUBLISH_JOB_PUBLISH_PRODUCT_LISTINGS',
	FetchProductPublishJobs = 'STORE_PRODUCT_PUBLISH_JOB_FETCH_PRODUCT_PUBLISH_JOBS',
	RetryProductPublishJob = 'STORE_PRODUCT_PUBLISH_JOB_RETRY_PRODUCT_PUBLISH_JOB',
	ClearCompletedProductPublishJobs = 'STORE_PRODUCT_PUBLISH_JOB_CLEAR_COMPLETED_PRODUCT_PUBLISH_JOBS',
	ClearFailedProductPublishJobs = 'STORE_PRODUCT_PUBLISH_JOB_CLEAR_FAILED_PRODUCT_PUBLISH_JOBS',
	ClearProductPublishJob = 'STORE_PRODUCT_PUBLISH_JOB_CLEAR_PRODUCT_PUBLISH_JOB',
}

export const PublishProductListings = (store: string, jsonData: string) => createAjaxAction<ProductPublishResponse>(StoreProductPublishJobActionType.PublishProductListings, {
	url: "ajax/api/user/stores/"+store+"/products/publish-jobs",
	method: "POST",
	data: jsonData as any,
	onFailure: (response, dispatch) => {
		if(response && response.data && response.data.error)
			dispatch(Toast(i18next.t(response.data.error)));
		else {
			dispatch(Toast(i18next.t('Something went wrong!')));
		}
	},
});

export const FetchProductPublishJobs = (
	store: string,
	batchId: string
) => createAjaxAction<ProductPublishResponse>(StoreProductPublishJobActionType.FetchProductPublishJobs, {
	url: "ajax/api/user/stores/"+store+"/products/publish-jobs?batch_id="+encodeURIComponent(batchId),
	method: "GET",
	onFailure: (response, dispatch) => {
		if(response && response.data && response.data.error)
			dispatch(Toast(i18next.t(response.data.error)));
		else {
			dispatch(Toast(i18next.t('Something went wrong!')));
		}
	},
});

export const RetryProductPublishJob = (
	store: string,
	id: number
) => createAjaxAction<{ job: ProductPublishJobPayload }>(StoreProductPublishJobActionType.RetryProductPublishJob, {
	url: "ajax/api/user/stores/"+store+"/products/publish-jobs/"+String(id)+"/retry",
	method: "POST",
	onFailure: (response, dispatch) => {
		if(response && response.data && response.data.error)
			dispatch(Toast(i18next.t(response.data.error)));
		else {
			dispatch(Toast(i18next.t('Something went wrong!')));
		}
	},
});

export const ClearCompletedProductPublishJobs = (
	store: string
) => createAjaxAction<{ cleared: number }>(StoreProductPublishJobActionType.ClearCompletedProductPublishJobs, {
	url: "ajax/api/user/stores/"+store+"/products/publish-jobs/clear-completed",
	method: "POST",
	onFailure: (response, dispatch) => {
		if(response && response.data && response.data.error)
			dispatch(Toast(i18next.t(response.data.error)));
		else {
			dispatch(Toast(i18next.t('Something went wrong!')));
		}
	},
});

export const ClearFailedProductPublishJobs = (
	store: string
) => createAjaxAction<{ cleared: number }>(StoreProductPublishJobActionType.ClearFailedProductPublishJobs, {
	url: "ajax/api/user/stores/"+store+"/products/publish-jobs/clear-failed",
	method: "POST",
	onFailure: (response, dispatch) => {
		if(response && response.data && response.data.error)
			dispatch(Toast(i18next.t(response.data.error)));
		else {
			dispatch(Toast(i18next.t('Something went wrong!')));
		}
	},
});

export const ClearProductPublishJob = (
	store: string,
	id: number
) => createAjaxAction<{ cleared: number, job: ProductPublishJobPayload }>(StoreProductPublishJobActionType.ClearProductPublishJob, {
	url: "ajax/api/user/stores/"+store+"/products/publish-jobs/"+String(id)+"/clear",
	method: "POST",
	onFailure: (response, dispatch) => {
		if(response && response.data && response.data.error)
			dispatch(Toast(i18next.t(response.data.error)));
		else {
			dispatch(Toast(i18next.t('Something went wrong!')));
		}
	},
});
